<template>
  <div
    v-if="isOpen"
    class="modal-werapper"
  >
    <div
      class="modal-background"
      @click="closeIfAllowed"
    />
    <div class="modal">
      <div class="modal-header">
        <div>
          <slot name="header">
            <p
              v-if="title"
              class="bold has-text-size-18 m-0"
            >
              {{ title }}
            </p>
          </slot>
        </div>
        <div
          v-if="canClose"
          class="close"
          @click="closeIfAllowed"
        >
          <IconsClose />
        </div>
      </div>
      <div class="modal-content">
        <div class="scroll-container">
          <div class="scroll-content">
            <slot :close="close" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  width: String,
  maxWidth: {
    type: String,
    default: "95%",
  },
  title: String,
  startOpened: {
    type: Boolean,
    default: false,
  },
  canClose: {
    type: Boolean,
    default: true,
  },
  okButtonText: String,
});

const emit = defineEmits(["close"]);

const isOpen = ref(props.startOpened);

function close() {
  isOpen.value = false;
  emit("close");
};

function closeIfAllowed() {
  if (props.canClose) {
    close();
  }
}

function open() {
  isOpen.value = true;
};

defineExpose({
  open,
  close,
})
</script>

<style scoped lang="scss">
.modal-werapper {
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  .modal-background {
    background: rgba(18, 18, 18, 0.4);
    position: fixed;
    inset: 0;
    z-index: 10;
    backdrop-filter: blur(1rem);
    -webkit-backdrop-filter: blur(1rem);
  }

  
  .modal {
    position: relative;
    width: v-bind(width);
    max-width: v-bind(maxWidth);
    background: white;
    padding: 12px;
    border-radius: 8px;
    z-index: 11;
    max-height: 95%;
    display: flex;
    flex-direction: column;
    
    .modal-header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      margin-left: 4px;
    }

    .modal-content {
      padding: 12px;
      overflow: hidden;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .scroll-container {
        position: relative;
        overflow: auto;
  
        .scroll-content {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .close {
    cursor: pointer;
  
    svg {
      display: block;
      margin: 0;
    }
  }
}

@media only screen and (max-width: 792px) {
  .popup {
    &-content {
      padding: 32px 16px 16px 16px;
      margin: 76px 16px 16px 16px;
      max-height: calc(100% - 75px);

      & > div {
        overflow: auto;
      }
    }
  }
}
</style>
